import { Box, Typography, useTheme } from '@mui/material';
import React from 'react';

const StatusButton = ({ text = "In Use", color = "primary" }) => {
    const theme = useTheme();
    return (
        <Box
            sx={{
                padding: "5px 15px",
                backgroundColor: color === "primary" ? "#FFDCC7CC" : color === "success" ? "#ECFDF5" : color === "gray" ? "#E7E9ECCC" : color === "red" ? "#FFEDED" : "#E7E9ECCC",
                display: "inline-block",
                borderRadius: "30px",
                position: "relative",
                "&::before": {
                    content: '""',
                    position: "absolute",
                    inset: 0,
                    borderRadius: "30px",
                    padding: "1px",
                    background: color === "primary" ? "linear-gradient(to top, #C58600, #C5860000)" : color === "success" ? "linear-gradient(to top, #10B981, #10B98100)" : color === "gray" ? "linear-gradient(to top, #9CA3AF, #9CA3AF00)" : color === "red" ? "linear-gradient(to top, #EF4444, #EF444400)" : "linear-gradient(to top, #9CA3AF, #9CA3AF00)",
                    WebkitMask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
                    WebkitMaskComposite: "destination-out",
                    maskComposite: "exclude",
                },
            }}
        >
            <Typography
                fontFamily={"Satoshi-Bold"}
                color={color === "primary" ? "#E28C00" : color === "success" ? theme.palette.bgSuccess.main : color === "gray" ? "#9CA3AF" : color === "red" ? "#EF4444" : "#9CA3AF"}
                fontSize={"16px"}
                whiteSpace={"nowrap"}
            >
                {text}
            </Typography>
        </Box>
    );
}

export default StatusButton;
